import { Component, OnInit, Input } from '@angular/core';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { UserData } from '../../models/user.model';
import { LucideAngularModule, Mic, Check, Play, Camera  } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ChangeProfilePictureDialogComponent } from 'src/app/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  @Input() show: boolean;
  firestore: FirebaseTSFirestore;
   storage = new FirebaseTSStorage();
  auth: FirebaseTSAuth;
  showError = false;

  profileForm: FormGroup;

  profilePhotoUrl: string = '';

  recordingStates: { [key: string]: boolean } = {}; // Indique si l'enregistrement est en cours
  audioBlobs: { [key: string]: Blob | null } = {}; // Stocke l'audio enregistré
  audioURLs: { [key: string]: string | null } = {}; // URL des enregistrements
  mediaRecorders: { [key: string]: MediaRecorder | null } = {}; // Enregistreurs audio
  audioPlayers: { [key: string]: HTMLAudioElement | null } = {}; // Lecteurs audio

  isPlaying: { [key: string]: boolean } = {};

  recordedAudioURLs: { [key: string]: string } = {}; // Stocke les URL des fichiers enregistrés


  

  constructor(private fb: FormBuilder, private dialog: MatDialog, private snackBar: MatSnackBar) {

    this.firestore = new FirebaseTSFirestore();
    this.auth = new FirebaseTSAuth();


    this.profileForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      profession: ['', [Validators.required]],
      city: ['', [Validators.required]]
    });
  }
  ngOnInit(): void {


    // Faire patienter l'utilisateur pendant 2 secondes avant de naviguer vers HomeComponent2
    setTimeout(() => {

      const currentUser = this.auth.getAuth().currentUser;

        /*// Vérifiez d'abord si currentUser n'est pas null
        if (currentUser && currentUser.uid) {
          //alert("iyeuh");
        } else {
          this.router.navigate(['/home2']); // Rediriger vers HomeComponent2 après 2 secondes
        } */
     
     
    }, 2500); // 2000 millisecondes = 2 secondes
  }

  // Démarrer/Arrêter l'enregistrement
  toggleRecording(field: string) {
    if (this.recordingStates[field]) {
      this.stopRecording(field);
    } else {
      this.startRecording(field);
    }
  }

  

  async startRecording(field: string) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks: Blob[] = [];

      recorder.ondataavailable = (event) => chunks.push(event.data);
      recorder.onstop = () => {
        this.audioBlobs[field] = new Blob(chunks, { type: 'audio/wav' });
        this.audioURLs[field] = URL.createObjectURL(this.audioBlobs[field]);
      };

      recorder.start();
      this.mediaRecorders[field] = recorder;
      this.recordingStates[field] = true;
    } catch (err) {
      console.error('Erreur d\'enregistrement :', err);
    }
  }

  stopRecording(field: string) {
    if (this.mediaRecorders[field]) {
      this.mediaRecorders[field].stop();
      this.recordingStates[field] = false;
    }
  }

  // Jouer/Arrêter l'audio
  

 

  togglePlayback(field: string) {

   

    if (!this.audioURLs[field]) {
      console.warn('Aucun enregistrement trouvé pour', field);
      return;
    }

    if (!this.audioPlayers[field]) {
      this.audioPlayers[field] = new Audio(this.audioURLs[field]);
      this.audioPlayers[field].onended = () => {
        this.isPlaying[field] = false;
      };
    }

    if (this.isPlaying[field]) {
      this.audioPlayers[field].pause();
      this.audioPlayers[field].currentTime = 0;
      this.isPlaying[field] = false;
    } else {
      this.audioPlayers[field].play();
      this.isPlaying[field] = true;
    }
  }

   // Méthode pour enregistrer un nouvel audio depuis le microphone
   saveRecordedAudio(soundKey: string, blob: Blob) {
    if (this.recordedAudioURLs[soundKey]) {
      URL.revokeObjectURL(this.recordedAudioURLs[soundKey]); // Nettoie l'ancien fichier
    }
    this.recordedAudioURLs[soundKey] = URL.createObjectURL(blob);
  }


  isFieldValid(fieldName: string): boolean {
    const control = this.profileForm.get(fieldName);
    return control?.valid && control?.touched;
  }

  onSubmit(): void {
    if (this.profileForm.valid) {
      console.log('Form Data:', this.profileForm.value);
    }
  }



  onChangeProfilePicture() {
    //const file = event.target.files[0];
    
    const dialogRef = this.dialog.open(ChangeProfilePictureDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Si une image est sélectionnée, mettre à jour la photo de profil
        this.uploadProfilePicture(result);
      } 
    }); 
  }

  uploadProfilePicture(image: string | ArrayBuffer) {
    // Convertir l'image en blob ou base64 pour l'envoyer à Firebase
    // Exemple de code pour uploader l'image sur Firebase Storage
  
    // Afficher un snack-bar de succès
    this.snackBar.open('Photo de profil modifiée avec succès!', 'Fermer', {
      duration: 3000,
    });
  }

  onChangeProfilePhoto(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const uploadMetadata: firebase.default.storage.UploadMetadata = {
        contentType: file.type // Type de contenu pour l'image (par exemple, 'image/jpeg')
      };
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.profilePhotoUrl = e.target.result;
        // Ouvrir le dialogue de recadrage ici, si nécessaire

        // Upload to Firebase Storage
        const userId = this.auth.getAuth().currentUser?.uid;
        if (userId) {
          const path = `Users/${userId}/profile_photo`;
          this.storage.upload(
            {
              uploadName: "Upload Profile Photo",
              path: [path],
              data: {
                data: file,
                metadata: { contentType: file.type }
              },
              onComplete: (downloadURL) => {
                // Handle successful upload and save the download URL in Firestore
                console.log("Profile photo uploaded!", downloadURL);
                this.profilePhotoUrl = downloadURL;
                this.firestore.update(
                  {
                    path: ["Users", userId],
                    data: {
                      profilePhotoUrl: downloadURL
                    }
                  }
                );
              },
              onFail: (error) => {
                console.error("Upload failed", error);
              }
            }
          );
        }
      };
      reader.readAsDataURL(file);
    }
  }
 

  

  onContinueClick2() {
    console.log("Continue button clicked");
    // Votre logique ici
  }

  onContinueClick(
    nameInput: HTMLInputElement,
    villeInput: HTMLInputElement,
    descriptionInput: HTMLTextAreaElement
  ) {
    if (nameInput.value && villeInput.value && descriptionInput.value) {
      // Tous les champs sont remplis, vous pouvez procéder
      this.showError = false;
      console.log('Formulaire validé:', {
        nom: nameInput.value,
        ville: villeInput.value,
        description: descriptionInput.value
      });

      let name = nameInput.value;
      let ville = villeInput.value;
      let description = descriptionInput.value;
      const userId = this.auth.getAuth().currentUser?.uid;

      if (userId) {
        // Enregistrer les audios dans Firebase Storage et obtenir les URLs
        const audioUploadPromises = Object.keys(this.audioBlobs).map(async (field) => {
          const blob = this.audioBlobs[field];
          if (blob) {
            const path = `Users/${userId}/audio/${field}.wav`;
            return this.storage.upload({
              uploadName: "Upload Audio",
              path: [path],
              data: {
                data: blob,
                metadata: { contentType: blob.type }
              }
            }).then((downloadURL) => {
              console.log(`Audio ${field} uploaded!`, downloadURL);
              return { field, downloadURL };
            }).catch((error) => {
              console.error(`Upload failed for ${field}`, error);
              return null;
            });
          }
          return null;
        });

        Promise.all(audioUploadPromises).then(async (audioURLs) => {
          const audioData = audioURLs.reduce((acc, audio) => {
            if (audio) {
              acc[audio.field] = audio.downloadURL;
            }
            return acc;
          }, {});

          // Vérifier si le document utilisateur existe déjà
          const userDoc = await this.firestore.getDocument({
            path: ["Users", userId]
          });

          const updateData: any = {
            publicName: name,
            ville: ville,
            description: description,
            profilePhotoUrl: this.profilePhotoUrl,
            coverPhotoUrl: "",
            followers: [],
            following: [],
            uid: userId
          };

          // Ajouter les URLs des audios dans des champs portant leurs noms respectifs
          Object.keys(audioData).forEach((field) => {
            updateData[field + "audioUrl"] = audioData[field];
          });

          if (userDoc.exists) {
            // Mettre à jour le document utilisateur existant
            this.firestore.update({
              path: ["Users", userId],
              data: updateData,
              onComplete: () => {
                alert("Votre profil a bien été mis à jour!");
                nameInput.value = "";
                descriptionInput.value = "";
              },
              onFail: (err) => {
                console.error("Erreur lors de la mise à jour du profil:", err);
              }
            });
          } else {
            // Créer un nouveau document utilisateur
            this.firestore.create({
              path: ["Users", userId],
              data: updateData,
              onComplete: (docId) => {
                alert("Votre profil a bien été créé!");
                nameInput.value = "";
                descriptionInput.value = "";
              },
              onFail: (err) => {
                console.error("Erreur lors de la création du profil:", err);
              }
            });
          }
        });
      }
    } else {
      // Affiche les messages d'erreur
      this.showError = true;
    }
  }

}





